<div *ngIf="invalidDemos.length" class="invalid-demos-container">
  <div class="invalid-demos-header" data-test-id="text-invalid-demos">
    <span translate translation="invalidDemos"></span>:
  </div>
  <div *ngFor="let demo of invalidDemos; let i = index">
    <span>{{ i + 1 }})&nbsp;</span>
    <a href="/uploads/demos/cup{{ cupId }}/{{ demo.demopath }}">{{ demo.demopath }}</a>
    <span> - {{ demo.reason }}</span>
  </div>
</div>
